import { render, staticRenderFns } from "./areaguide.vue?vue&type=template&id=4ee48a37&scoped=true"
import script from "./areaguide.vue?vue&type=script&lang=ts"
export * from "./areaguide.vue?vue&type=script&lang=ts"
import style0 from "./areaguide.vue?vue&type=style&index=0&id=4ee48a37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee48a37",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonPageTitle: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/page-title.vue').default,TopNotification: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/top/notification.vue').default,AreaguideMap: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/areaguide/map.vue').default,AreaguideProgram: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/areaguide/program.vue').default})
